import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"

import Dice from "@frog/source/data/games/dice/views/Dice.jsx"
import DiceCube from "@frog/source/data/games/dice/views/DiceCube.jsx"

import CarryOn from "@frog/source/data/games/dice/scripts/CarryOn.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import "./Modals.less"

function onClick(stage) {
    return (event) => {
        window.hasRolled = true
        CarryOn(stage)
    }
}

export default function RollModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return
            const units = Object.values(stage.units).filter((unit) => {
                return unit.isDead != true
                    && unit.isLockedIn != true
                    && unit.affiliation == stage.player.affiliation
                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
            })
            if(units.length == 0) return
            return (
                <div class="RollModal">
                    <div class="Fill"/>
                    <div class="Content">
                        <div class="Header">
                            <div class="BigText">Roll the Dice</div>
                        </div>
                        <section class="UnitsSection" onClick={onClick(stage)}>
                            {units.map((unit) => {
                                return (
                                    <DiceCube item={unit.diceFaces[0]} unit={unit} stage={stage} animation="spin"/>
                                )
                            })}
                        </section>
                    </div>
                </div>
            )
        }
    })
}
